import React from 'react';
import { remCss, scssVariables as variables } from 'src/helpers';
const PlusIcon = React.memo(
  ({
    fill = variables['colors-mc-text-primary'],
    width = 25.716,
    height = 25.717,
    viewBox = '0 0 25.716 25.717'
  }) => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={remCss(width)}
      height={remCss(height)}
      viewBox={viewBox}
    >
      <path
        id='Union_2'
        data-name='Union 2'
        d='M10.929,23.787v-9h-9a1.929,1.929,0,1,1,0-3.857h9v-9a1.929,1.929,0,1,1,3.857,0v9h9a1.929,1.929,0,0,1,0,3.857h-9v9a1.929,1.929,0,0,1-3.857,0Z'
        transform='translate(0 0.001)'
        fill={fill}
        opacity='0.67'
      />
    </svg>
  )
);
PlusIcon.displayName = 'PlusIcon';

export default PlusIcon;
